<template>
  <section>
    <section-title title="Búsqueda de Especialista" />
    <div class="container-fluid">
      <validation-observer
        v-if="isSearchByHdnActive != null"
        ref="formValidator"
      >
        <div class="row mb-5">
          <div v-if="isSearchByHdnActive" class="col-md-4 col-sm-12">
            <validation-observer ref="validator">
              <validation-provider
                v-slot="{ errors, failedRules }"
                rules="required|max:16"
              >
                <label class="data-label">
                  SSN o Número de Registro de Salud:
                </label>
                <input
                  v-model.number="ssnOrHdn"
                  class="form-control"
                  :class="{ invalid: errors.length > 0 }"
                  :maxlength="16"
                  placeholder="Escribir SSN o Número de Registro de Salud"
                  type="number"
                />
                <custom-error
                  v-if="errors.length > 0 && failedRules.required"
                  class="position-absolute"
                  message="El campo es requerido"
                  variant="no-border mt-1"
                />
                <custom-error
                  v-else-if="errors.length > 0 && failedRules.max"
                  class="position-absolute"
                  message="El campo no debe ser mayor a 16 caracteres"
                  variant="no-border mt-1"
                />
              </validation-provider>
            </validation-observer>
          </div>
          <div v-else class="col-md-3 col-sm-12">
            <validation-observer ref="validator">
              <validation-provider
                v-slot="{ errors }"
                rules="required|ssn"
                vid="ssnVP"
              >
                <custom-input
                  v-model="specialistData.socialSecurityNumber"
                  :custom-error-msg="ssnErrorMessage"
                  :error="errors[0]"
                  error-class="position-absolute"
                  label="SSN:"
                  mask-type="Personalssn"
                  placeholder="XXX-XX-XXXX"
                />
              </validation-provider>
            </validation-observer>
          </div>
          <div class="col-lg-2 col-md-4 col-12 mt-3 d-flex align-items-end">
            <action-button
              class="h-btn w-100"
              i="fas fa-search"
              text="Buscar"
              variant="success"
              @click="search"
            />
          </div>
        </div>
        <div v-if="showSpecialistCreation">
          <hr />
          <div class="row">
            <div class="col-sm">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-model="specialistData.firstName"
                  :custom-error-msg="errorMsgs.firstName"
                  :error="errors[0]"
                  label="Nombre:"
                />
              </validation-provider>
            </div>
            <div class="col-sm">
              <custom-input
                v-model="specialistData.middleName"
                label="Segundo Nombre:"
              />
            </div>
            <div class="col-sm">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-model="specialistData.lastPaternalName"
                  :custom-error-msg="errorMsgs.lastPaternalName"
                  :error="errors[0]"
                  label="Apellido Paterno:"
                />
              </validation-provider>
            </div>
            <div class="col-sm">
              <custom-input
                v-model="specialistData.lastMaternalName"
                label="Apellido Materno:"
              />
            </div>
            <div class="col-sm">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-model="specialistData.email"
                  :custom-error-msg="errorMsgs.email"
                  :error="errors[0]"
                  label="Correo Electrónico:"
                />
              </validation-provider>
            </div>
            <div v-if="this.isEducationDepartment()" class="col-sm">
              <custom-input
                v-model="specialistData.staffId"
                :disabled="disabled"
                label="Número de KRONO:"
              />
            </div>
          </div>
        </div>
      </validation-observer>
    </div>
  </section>
</template>

<script>
import SectionTitle from '@/components/common/page/SectionTitle';
import CustomInput from '@/components/common/form/CustomInput';
import CustomError from 'custom-error';
import {
  getSpecialistBySSN,
  isSsnValid,
  getSpecialistBySsnOrHdn,
} from '@/modules/provider/api';
import { mapState } from 'vuex';
import alert from '@/mixins/alert.mixin';
import Departments from '@/utils/constants/departmentsId';
import { getSysparameterByNames } from '@/modules/shared/sysparameter.api';

export default {
  name: '',
  components: {
    SectionTitle,
    CustomInput,
    CustomError,
  },
  mixins: [alert],
  props: {
    csseFormValidator: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      consulted: false,
      ssnOrHdn: null,
      specialistData: {
        id: null,
        socialSecurityNumber: null,
        firstName: null,
        middleName: null,
        lastPaternalName: null,
        lastMaternalName: null,
        email: null,
        staffId: null,
        isRelatedToMaster: null,
      },
      searchResult: null,
      isSsnValid: true,
      isSearchByHdnActive: null,
      errorMsgs: {
        firstName: 'Favor ingresar el nombre. (0115)',
        lastPaternalName: 'Favor ingresar el apellido paterno. (0118)',
        email: 'El campo Correo Electrónico es requerido. (0518)',
      },
    };
  },
  computed: {
    ...mapState('$_user', ['user']),
    page() {
      return {
        title: 'Información de Especialista',
        icon: 'fas fa-user-tie',
        routes: ['Proveedor', 'Especialistas'],
      };
    },
    availableActions() {
      return [
        {
          text: 'Regresar',
          icon: 'far fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => this.$router.push({ name: 'search-specialist' }),
        },
        {
          component: 'ActionButton',
          variant: 'success',
          text: 'Guardar',
          icon: 'fas fa-save',
          click: this.save,
          visible: this.consulted,
        },
      ];
    },
    showSpecialistCreation() {
      return !!this.searchResult && !this.searchResult.id;
    },
    ssnErrorMessage() {
      let length = (this.specialistData.socialSecurityNumber || []).length;
      let message;

      if (length == 0) {
        message = 'Favor entrar un número de seguro social.';
      } else if (length < 9 || !this.isSsnValid) {
        message = 'El número de seguro social entrado no es valido.';
      }
      return message;
    },
  },
  created() {
    this.$emit('on-create', this.availableActions);
  },
  async mounted() {
    await this.getCreateSpecialistBySearchHealthDepartmentNumberSysParam();
  },
  methods: {
    departments() {
      return Departments;
    },
    isEducationDepartment() {
      return (
        Number(this.$route.params.companyId) ===
          this.departments().EducationDepartmentId ||
        Number(this.user.profile.companyid) ===
          this.departments().EducationDepartmentId
      );
    },
    async save() {
      var self = this;
      const userFormIsValid = await this.$refs['formValidator'].validate();
      const csseFormIsValid = await this.csseFormValidator.validate();

      if (userFormIsValid && csseFormIsValid) {
        self.specialistData.fullName = `${self.specialistData.firstName} ${self.specialistData.middleName} ${self.specialistData.lastPaternalName} ${self.specialistData.lastMaternalName}`.trim();
        if (this.isSearchByHdnActive) {
          if (this.isSsnValid)
            self.specialistData.socialSecurityNumber = `${this.ssnOrHdn}`;
          else {
            self.specialistData.registrationNumber = `${this.ssnOrHdn}`;
          }
        }
        self.specialistData = self.$emit(
          'on-specialist-added',
          self.specialistData
        );
      } else {
        self.ShowToast(
          'Error',
          'Favor de completar la información solicitada.',
          'error'
        );
      }
    },
    async search() {
      const companyIdToRequest =
        this.user.profile.companyid == null
          ? this.$route.params.companyId
          : this.user.profile.companyid;

      const isValid = await this.$refs.validator.validate();
      const ssn = this.isSearchByHdnActive
        ? this.ssnOrHdn
        : this.specialistData.socialSecurityNumber;
      if (isValid) {
        const { data } = await isSsnValid(ssn);
        this.isSsnValid = data;
        if (!data.isSsnValid && !this.isSearchByHdnActive) {
          this.$refs.validator.setErrors({
            ssnVP: [this.ssnErrorMessage],
          });
        }
      }

      if (!isValid || (!this.isSearchByHdnActive && !this.isSsnValid)) {
        this.ShowToast(
          'Error',
          'Favor de completar la información solicitada.',
          'error'
        );
        return;
      }
      try {
        const searchValue = this.isSearchByHdnActive
          ? this.ssnOrHdn
          : this.specialistData.socialSecurityNumber.replace(/-/gi, '');

        const { data } = this.isSearchByHdnActive
          ? await getSpecialistBySsnOrHdn(searchValue, companyIdToRequest)
          : await getSpecialistBySSN(searchValue, companyIdToRequest);
        if (!data) return;

        if (
          data.isRelatedToOwnCompany ||
          (data.isRelatedToRPCompany && !data.canCreateSpecialistWithExcemption)
        ) {
          this.ShowToast('Atención', data.resultMessage, 'warning');
          return;
        }
        if (data.isRelatedToMaster && data.isRelatedToRPCompany) {
          this.ShowToast('Atención', data.resultMessage, 'warning');
          return;
        }
        this.consulted = true;

        this.$emit('on-create', this.availableActions);

        if (!data.isRelatedToMaster) {
          this.searchResult = data;
        }
        if (data.id) {
          this.$emit('on-specialist-found', data);
        }
        if (data.isRelatedToMaster && data.userId) {
          const answer = await this.ShowCancelModal(
            'Atención',
            data.resultMessage,
            'Sí',
            'No'
          );
          if (!answer) return;

          this.searchResult = data;

          if (this.isSearchByHdnActive && this.isSsnValid) {
            this.specialistData.socialSecurityNumber = ssn;
          }
          this.specialistData = {
            ...this.specialistData,
            firstName: data.firstName,
            middleName: data.middleName,
            lastPaternalName: data.lastPaternalName,
            lastMaternalName: data.lastMaternalName,
            staffId: data.staffId,
            isRelatedToMaster: data.isRelatedToMaster,
            userId: data.userId,
          };
          await this.save();
        }
      } catch (err) {
        this.ShowToast(
          'Error',
          err?.response?.data?.message || err?.message || err,
          'error'
        );
      }
    },
    async getCreateSpecialistBySearchHealthDepartmentNumberSysParam() {
      const { data } = await getSysparameterByNames({
        parameterNames: ['CreateSpecialistBySearchHealthDepartmentNumber'],
      });
      this.isSearchByHdnActive =
        data?.length > 0 && data[0].staticValue?.toLowerCase() === 'true';
    },
  },
};
</script>

<style scoped>
.h-btn {
  height: 40px;
}

.form-control.invalid {
  border: 1px solid #ff5b5c;
}
</style>
